import { AliasPageName } from 'src/app/gamification/cv-marketplace-admin/models/gamification-pages.model';
import { Component, OnInit } from '@angular/core';
import { PointStorePermissionService } from 'src/app/gamification/marketplace/admin/services/point-store-permission.service';

@Component({
    selector: 'cv-admin-budget',
    templateUrl: './cv-admin-budget.component.html',
    styleUrls: ['./cv-admin-budget.component.scss']
})
export class CvAdminBudgetComponent implements OnInit {

    constructor(
        private pointStorePermissionService: PointStorePermissionService,
    ) { }

    ngOnInit(): void {
        this.loadPermissionList();
    }

    async loadPermissionList() {
        await this.pointStorePermissionService.loadPermission(
            this.pointStorePermissionService.pageNameFilter(AliasPageName.BudgetTab)
        );
    }
}